<template>
    <div>
        <detail-panel
            v-if="selectedObject"
            :objects="getObjects"
            :selectedObject="selectedObject"
            :style="$_getStyle"
            class="detail-panel shadowSmall"
            :class="{ show: showDetailPanel }"
            :active="isActive"
            @open="$_selectObjectFromDetail($event)"
            @hide="$_hideDetails()"
        />
        <b-tabs
            class="tabs-container"
            content-class="custom-tab-content"
            active-nav-item-class="text-primary"
            v-model="tabIndex"
        >
            <b-tab
                v-for="(tab, index) in orderedTabsWithData"
                :key="index"
                title-link-class="close-tab"
                @click="$_changeTabClick(tab.type === TAB_TYPES.POINTER)"
            >
                <!-- Title -->
                <template #title>
                    <tab-title
                        v-if="tab"
                        :title="tab.title"
                        :count="tab.count"
                        :status="tab.status"
                        @closeTab="$_closeTab(tab)"
                    />
                </template>
                <!-- Tab contextmenu  -->
                <context-menu
                    v-if="tab && tab.type === TAB_TYPES.POINTER"
                    :context-object="{
                        point: pointer?.location?.point,
                        address: $store.getters.getSearchAddress
                    }"
                    @openBrkDetails="$emit('openBrkDetails', $event)"
                    @openStufDetails="$emit('openStufDetails', $event)"
                    @openKvkDetails="$emit('openKvkDetails', $event)"
                    @openEnergyLabel="$emit('openEnergyLabel', $event)"
                    @openWozData="$emit('openWozData', $event)"
                ></context-menu>
                <!-- Tab object searchresults -->
                <object-searchresults-info-tab
                    v-if="tab && tab.type === TAB_TYPES.ADMIN"
                    :dataObject="{
                        title: tab.title,
                        data: tab.data,
                        id: tab.index,
                        maxResultsExceeded: tab.maxResultsExceeded,
                        message: tab.message,
                        status: tab.status,
                        count: tab.count
                    }"
                    :selectedObject="selectedObject"
                    @openObject="$_openDetailsFromTableApiResult"
                ></object-searchresults-info-tab>
                <!-- Tab layers -->
                <div
                    v-if="tab.type === TAB_TYPES.LAYER"
                    class="features-information"
                >
                    <!-- In case of results, show table -->
                    <layer-features-info-tab
                        :group="tab && tab.group"
                        :selectedObject="selectedObject"
                        @openObject="$_openDetailsFromTable"
                        @sortObjects="$_sortObjects"
                        @openBrkDetails="$emit('openBrkDetails', $event)"
                        @openStufDetails="$emit('openStufDetails', $event)"
                        @openKvkDetails="$emit('openKvkDetails', $event)"
                    />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS, TAB_TYPES } from '../../../../constants';
    import { isSmallDevice } from '../../../../services/utilities/devices';
    import LayerFeaturesInfoTab from '../../information/selection/SelectionResultGroup';
    import ObjectPanel from './ObjectPanel.vue';
    import ContextMenu from './ContextTab.vue';
    import ObjectSearchresultsTab from './ObjectSearchresultsTab.vue';
    import TabTitle from './TabTitle.vue';
    import Vue from 'vue';

    export default {
        props: {
            groups: { type: Array, required: true },
            objects: { type: Array, required: true },
            orderedTabs: { type: Array, required: true }
        },
        components: {
            'layer-features-info-tab': LayerFeaturesInfoTab,
            'context-menu': ContextMenu,
            'object-searchresults-info-tab': ObjectSearchresultsTab,
            'detail-panel': ObjectPanel,
            'tab-title': TabTitle
        },
        data() {
            return {
                tabIndex: 0,
                selectedObject: null,
                TAB_TYPES: TAB_TYPES,
                titleActiveTab: '',
                newTabIndexSet: false,
                tabIndexOnClose: 0,
                tabIndexToSet: null,
                localObjects: []
            };
        },
        computed: {
            ...mapGetters([
                'isMobile',
                'getDetailInformationPanelHeight',
                'getObjectDataSelectedItem',
                'getSelectionGroups',
                'getTabToFocus'
            ]),
            ...mapState([
                'uiElements',
                'pointer',
                'pointerFocus',
                'tabObjectSearch',
                'objectSearchResults'
            ]),
            detailPanel: function () {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION]
                    .components.detailPanel;
            },
            indexTabPointer() {
                return this.pointer ? 1 : 0;
            },
            indexTabObject() {
                return this.tabObjectSearch ? this.objectSearchResults.length : 0;
            },
            showDetailPanel() {
                return this.detailPanel.visible && !!this.selectedObject;
            },
            isActive() {
                // activate detail panel (for zooming in & highlighting feature on map)
                // even if no attributes are shown
                return this.showDetailPanel || !this.hasDetailInfo;
            },
            hasDetailInfo() {
                return this.selectedObject?.info.length > 0;
            },
            $_getStyle() {
                const resize = this.detailPanel.resize;
                const extra = this.isMobile ? 0 : 10;
                return resize
                    ? `bottom: ${this.getDetailInformationPanelHeight + extra}px`
                    : null;
            },
            getObjects() {
                if (this.selectedObject?.type === 'api') {
                    const objectsInGroup =
                        this.objectSearchResults[this.selectedObject.groupIndex];
                    return objectsInGroup.data.items;
                }
                return this.localObjects;
            },
            getOrderedTabsWatch() {
                return this.orderedTabs;
            },
            orderedTabsLength() {
                return this.orderedTabs.length;
            },
            orderedTabsWithData() {
                try {
                    const orderedTabsWithData = this.orderedTabs.map((tab) => {
                        // Get themelayer data
                        if (tab && tab.type === TAB_TYPES.LAYER) {
                            const group = this.getSelectionGroups.find(
                                (g) => g.title === tab.title
                            );
                            return {
                                title: tab.title,
                                type: tab.type,
                                status: tab.status,
                                count: group?.count ?? 0,
                                group
                            };

                            // Get table data
                        } else if (tab && tab.type === TAB_TYPES.ADMIN) {
                            // Get the index from the objectdata within the objectSearchResults
                            const index = this.objectSearchResults.findIndex(
                                (o) => o.title === tab.title
                            );
                            // get the objectdata itself
                            const obj = this.objectSearchResults[index];
                            return {
                                title: tab.title,
                                type: tab.type,
                                status: tab.status,
                                index: index,
                                count: obj?.count ?? 0,
                                data: obj?.data,
                                maxResultsExceeded: obj?.maxResultsExceeded,
                                message: obj?.message
                            };
                            // Other tabs (i.e. long press)
                        } else {
                            return { ...tab };
                        }
                    });
                    return orderedTabsWithData;
                } catch (error) {
                    console.log('error', error);
                    return [];
                }
            }
        },
        watch: {
            pointer(newVal) {
                if (newVal) {
                    // let the component update first so the ref is available
                    Vue.nextTick(() => {
                        // activate the tab because there is a new value for the pointer
                        this.$refs.pointerTab?.activate();
                    });
                }
            },
            groups: {
                handler: function (newVal) {
                    this.$_hideDetails();
                    this.localObjects = [...this.objects];

                    if (isSmallDevice() && newVal.length > 0) {
                        const firstGroupWithObjects = newVal.find(
                            ({ objects }) => objects.length > 0
                        );
                        if (firstGroupWithObjects) {
                            if (
                                this.uiElements[
                                    INTERFACE_PANEL_TRIGGERS.FEEDBACK_EDIT
                                ]?.visible === false
                            ) {
                                this.$_openDetailsFromTable({
                                    group: firstGroupWithObjects,
                                    index: 0
                                });
                            }
                        }
                    }
                },
                immediate: true
            },
            tabIndex: {
                handler: function (newVal) {
                    if (newVal !== -1) {
                        // Depending on which tab is being clicked perform some action
                        // Layers, highlight layer data
                        if (this.orderedTabs[newVal]?.type === TAB_TYPES.LAYER) {
                            // Find the position of the group within the selections array.
                            const groupIndex = this.getSelectionGroups.findIndex(
                                (g) => g.title === this.orderedTabs[newVal]?.title
                            );
                            this.$store.dispatch('updateSelectionPointer', {
                                group: groupIndex,
                                index: -1
                            });

                            // Tables: highlight possible themelayer data
                        } else if (
                            this.orderedTabs[newVal]?.type === TAB_TYPES.ADMIN
                        ) {
                            this.$store.dispatch('displaySelectedItemObjectData', {
                                groupTitle: this.orderedTabs[newVal]?.title
                            });
                        }
                    }
                },
                immediate: true
            },

            // if the number of tabs has changed, react to this.
            orderedTabsLength: {
                handler: function (newLength, oldLength) {
                    if (newLength === oldLength) {
                        return;
                    }

                    // When tabs are being closed set the active tab to the calculated value this.tabIndexOnClose
                    if (newLength < oldLength) {
                        this.tabIndex = this.tabIndexOnClose ?? 0;
                        this.RESET_SELECTIONS_FOCUS();
                    } else if (this.getTabToFocus) {
                        // when opening a relation from a tab this.getTabToFocus is set to the title of the tab from
                        // which the relation is being opened.
                        // The relation tab is added to the end so we focus on the last tab.
                        // We then reset this.getTabToFocus
                        this.clearTabToFocus();
                        this.tabIndex = newLength - 1;

                        // In some circumstances the tab on position tabIndex is not ready to navigate to
                        // the tabIndex is then reset automatically. We have to wait for a change in getOrderedTabs
                        // see getOrderedTabsWatch
                        this.tabIndexToSet = newLength - 1;
                    } else {
                        // No relation was openend so we focus on the first tab.
                        this.tabIndex = 0;
                    }
                },
                immediate: true
            },
            getOrderedTabsWatch: {
                handler: function (newVal) {
                    // If the tabtofocus has a value set index to the last tab.
                    if (this.getTabToFocus) {
                        this.clearTabToFocus();
                        this.tabIndex = this.orderedTabsLength - 1;
                        return;
                    }
                    // When the tab array has changed and the tabIndex is not yet on the value we want it to be,
                    // set it to that value now.
                    if (this.tabIndexToSet && this.tabIndex != this.tabIndexToSet) {
                        // set tabindex to desired value
                        this.tabIndex = this.tabIndexToSet;
                        // reset desired value
                        this.tabIndexToSet = null;
                    }
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            ...mapMutations([
                'RESET_SELECTIONS_FOCUS',
                'MAP_ADD_DRAWING',
                'TOGGLE_OBJECT_DETAIL_PANEL'
            ]),
            ...mapActions(['clearTabToFocus']),
            $_sortObjects(data) {
                this.localObjects.forEach((object) => {
                    const index = data.sortedObjects.findIndex(
                        (bl) => bl.info.nedGlobeRowId === object.nedGlobeRowId
                    );
                    object.index = index;
                });

                // Find the indices of elements with the target layerId
                let targetIndices = this.localObjects
                    .map((object, index) => object.layerId === data.layerId ? index : -1)
                    .filter(index => index !== -1);

                // Extract the matching elements using the found indices
                let matchingItems = targetIndices.map(index => this.localObjects[index]);

                // Sort the matching elements
                matchingItems.sort((a, b) => a.index - b.index);
                // Replace the original elements in `data` with the sorted ones
                targetIndices.forEach((index, i) => {
                    this.localObjects[index] = matchingItems[i];
                });
            },
            $_openDetailsFromTableApiResult({ groupIndex, itemIndex }) {
                this.selectedObject = this.getObjectDataSelectedItem(
                    groupIndex,
                    itemIndex
                );
                this.$_showDetails();
                this.$emit('openDetails');
            },
            $_openDetailsFromTable({ group, index }) {
                const objectsInGroup = this.localObjects.filter(
                    ({ layerId }) => layerId === group.id
                );
                this.selectedObject = objectsInGroup[index];
                this.$_showDetails();
                this.$emit('openDetails');
            },
            $_closeTab(tab) {
                this.$_getTabIndexOnClose(tab);

                if (this.orderedTabs.length === 1) {
                    // Remove existing drawings when last tab is being closed
                    // This is to remove selection polygon/circle
                    this.MAP_ADD_DRAWING({ mapName: 'main', feature: null });
                }

                if (tab.type === TAB_TYPES.POINTER) {
                    this.$store.dispatch('removeNedGlobePointer');
                    this.$store.dispatch('clearParcelContour');
                } else if (tab.type === TAB_TYPES.LAYER) {
                    this.$store.dispatch('removeTabGroup', { title: tab.title });
                } else if (tab.type === TAB_TYPES.ADMIN) {
                    this.$store.dispatch('removeTabObjectSearch', {
                        title: tab.title
                    });
                }
                this.$store.dispatch('removeTabFromTabOrder', { title: tab.title });
                this.$_hideDetails();
            },
            $_getTabIndexOnClose(tab) {
                // find position of closing tab
                const closeIndex = this.orderedTabs.findIndex(
                    (o) => o.title === tab.title
                );

                // Closing tab can be left of current tab or equal to current tab. In both cases move 1 tab to the left
                // but do not go past 0
                // If closing tab is beyond current tab. No change needed.
                if (closeIndex <= this.tabIndex) {
                    this.tabIndexOnClose = Math.max(0, this.tabIndex - 1);
                }
            },
            $_changeTabClick(pointerTab) {
                this.selectedObject = null;
                if (pointerTab) {
                    // Tab "geprikte locatie" is visible
                    this.$store.dispatch('showParcelContour');
                    this.$store.dispatch('showNedGlobePointer');
                } else {
                    this.$store.dispatch('clearParcelContour');
                    this.$store.dispatch('hideNedGlobePointer');
                    this.TOGGLE_OBJECT_DETAIL_PANEL(false);
                }
            },
            $_selectObjectFromDetail(object) {
                this.selectedObject = object;
            },
            $_showDetails() {
                // only show info panel if it has attributes to show
                if (this.hasDetailInfo) {
                    this.$store.dispatch('togglePanel', {
                        panelName: INTERFACE_PANEL_TRIGGERS.OBJECT_DETAILS,
                        visible: true
                    });
                }
            },
            $_hideDetails() {
                this.selectedObject = null;
                this.$store.state.selectedItemIndex = null;
                this.$store.dispatch('displaySelectedItem', {});
                this.$store.dispatch('togglePanel', {
                    panelName: INTERFACE_PANEL_TRIGGERS.OBJECT_DETAILS,
                    visible: false
                });
            }
        }
    };
</script>

<style lang="scss">
.information-tab-content .tabs-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    .custom-tab-content {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 100%;
        position: relative;
        .tab-pane {
            height: 100%;
            & .features-information {
                height: 100%;
                position: relative;
                display: flex;
                flex-direction: column;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.detail-panel {
    @include z-index(details-panel);
    position: fixed;
    left: -$object-panel-width;
    top: var(--paneltop);
    bottom: 0;
    width: $object-panel-width;
    background-color: #fff;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    &.show {
        left: 0;
        .web-map & {
            @include margin-left-navbar;
            max-height: calc(100% - $menu-bar-height - 10px);
        }
    }
}

@media (max-width: 767px) {
    .detail-panel.show {
        width: 100%;

        .web-map & {
            width: calc(100% - 20px);
        }
    }
}
</style>
